<template>
    <div class="price-container" :class="priceContainerClass" :style="priceContainerStyle">
        <slot name="before" />
        <!-- unit -->
        <span :class="lUnitClass" :style="lUnitStyle">{{unit}}</span>
        <!-- count -->
        <span :class="lCountClass" :style="lCountStyle">{{count}}</span>
        <slot name="after" />
    </div>
</template>

<script>
export default {
    name: 'Price',
    components: {},
    props: {
        unit: {
            type: String,
            default: '￥'
        },
        unitColor: {
            type: String,
            default: '#333'
        },
        unitSize: {
            type: [String, Number],
            default: 14
        },
        unitBold: {
            type: String,
            default: 'normal'
        },
        count: {
            type: [String, Number],
            default: 0.0
        },
        countColor: {
            type: String,
            default: '#333'
        },
        countSize: {
            type: [String, Number],
            default: 14
        },
        countBold: {
            type: String,
            default: 'normal'
        },
        delete: {
            type: Boolean,
            default: false
        },
        delColor: {
            type: String,
            default: '#777'
        },
        lClass: {
            type: String,
            default: ''
        },
        lUnitClass: {
            type: String,
            default: ''
        },
        lCountClass: {
            type: String,
            default: ''
        }
    },
    data() {
        return {}
    },
    computed: {
        priceContainerClass() {
            return [this.lClass, this.delete ? 'price-del' : '']
        },
        priceContainerStyle() {
            return { color: this.delColor }
        },
        lUnitStyle() {
            return {
                color: this.delete ? this.delColor : this.unitColor,
                fontSize: this.unitSize + 'px',
                fontWeight: this.unitBold
            }
        },
        lCountStyle() {
            return {
                color: this.delete ? this.delColor : this.countColor,
                fontSize: this.countSize + 'px',
                fontWeight: this.countBold
            }
        }
    }
}
</script>
<style lang='stylus' scoped>
.price-del
    text-decoration: line-through !important
.price-container
    display: inline-block
    text-align: center
</style>
